// How the weekly challenge works (scenario Q9,
// PLAN-2026-11-01-the-weekly-challenge §7): the words behind the info button
// on the League page's card and the page's title, and a panel of its own on
// the page. One copy, so the two never say different things.

import { InfoButton } from '../../kit/InfoButton';
import { Stack, Text } from '../../kit/ui';
import '../../styles/screens/challenge.css';

/** The steps. `captain` is how many times over a captain's points count. */
export function ChallengeSteps({ captain }: { captain: number }) {
  const times = captain === 1.5 ? 'one and a half times' : `${captain} times`;
  return (
    <Stack gap={3}>
      <ol className="fsp-challenge-steps">
        <li>
          <Text weight="strong" block>
            A new challenge every week.
          </Text>
          <Text size="sm" tone="secondary" block>
            Each week draws two positions and three things each is scored on, the same for everybody
            on the site. The season’s first week opens a week before its first game, and each week
            after it as soon as the week before it kicks off, so during the season there’s always
            one to pick.
          </Text>
        </li>
        <li>
          <Text weight="strong" block>
            Pick one player from each tier.
          </Text>
          <Text size="sm" tone="secondary" block>
            Each position’s players are split into three tiers by fantasy points a game. Anybody can
            pick anybody, so the question is who is good at this week’s categories.
          </Text>
        </li>
        <li>
          <Text weight="strong" block>
            Make one of them your captain.
          </Text>
          <Text size="sm" tone="secondary" block>
            Your captain’s points count {times}.
          </Text>
        </li>
        <li>
          <Text weight="strong" block>
            Change your mind until kickoff.
          </Text>
          <Text size="sm" tone="secondary" block>
            Picks save as you go. Each one locks when his game starts, and points come in the
            morning after each game.
          </Text>
        </li>
        <li>
          <Text weight="strong" block>
            Climb the boards.
          </Text>
          <Text size="sm" tone="secondary" block>
            The most points wins the week, and a tie goes to the captain who scored more. Your
            league has its own board, and everybody’s shows the name you chose.
          </Text>
        </li>
      </ol>
      <Text size="sm" tone="secondary" block>
        It’s for bragging rights: nothing to pay, and nothing to win but a place on the board.
      </Text>
    </Stack>
  );
}

/** The ⓘ beside the challenge's name: the steps, when asked. */
export function ChallengeInfo({ captain = 1.5 }: { captain?: number }) {
  return (
    <InfoButton label="How the weekly challenge works" title="How the weekly challenge works">
      <ChallengeSteps captain={captain} />
    </InfoButton>
  );
}
